if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								top: elm.offsetTop - 50,
								behavior: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				if ( this.productGallery.dataset.jsDisableParallax == 'false' ) {
					this.productSlider.addEventListener('ready', (e)=>{
						
						if ( this.firstProductGalleryIndex ) {
							this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
						}

						const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
						const productFigures = this.querySelectorAll('.apply-gallery-animation');
						this.productSlider.addEventListener('scroll', ()=>{
							const scrollX = -this.productSlider.element.scrollLeft;
							productSlides.forEach((slide,i)=>{
								const media = productFigures[i];
								if ( media ) {
									media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
								}
							});
						});

					});
				}

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action == 'overlay' || KROWN.settings.cart_action == 'popup' ) ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
							window.lastFocusedElm = this.querySelector('[data-js-product-add-to-cart]');
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
								addToCartEnter = false;
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

			this.handleRedesignV2DividerContent = this.handleRedesignV2DividerContent.bind(this);
			this.handleRedesignV2DividerContent();
			window.addEventListener('resize', this.handleRedesignV2DividerContent);

			this.handleMobileIntroReorder = this.handleMobileIntroReorder.bind(this);
			this.handleMobileIntroReorder();
			window.addEventListener('resize', this.handleMobileIntroReorder);

		}

		handleRedesignV2DividerContent() {

			if ( !document.body.classList.contains('pdp-redesign') ) {
				return;
			}

			if ( !this.productGallery ) {
				return;
			}

			const productText = this.querySelector('.product-text');
			if ( !productText ) {
				return;
			}

			const dividers = productText.querySelectorAll(':scope > span.divider');
			if ( dividers.length < 2 ) {
				this.restoreRedesignV2DividerContent();
				return;
			}

			if ( !this.redesignV2DividerStart ) {
				this.redesignV2DividerStart = dividers[0];
				this.redesignV2DividerEnd = dividers[1];
			}

			if ( !this.redesignV2DividerPlaceholder ) {
				this.redesignV2DividerPlaceholder = document.createElement('span');
				this.redesignV2DividerPlaceholder.hidden = true;
				this.redesignV2DividerPlaceholder.className = 'product-gallery__relocated-info-placeholder';
				this.redesignV2DividerEnd.parentNode.insertBefore(this.redesignV2DividerPlaceholder, this.redesignV2DividerEnd);
			}

			if ( !this.redesignV2DividerNodes ) {
				this.redesignV2DividerNodes = [];
				let currentNode = this.redesignV2DividerStart.nextSibling;

				while ( currentNode && currentNode !== this.redesignV2DividerEnd ) {
					const nextNode = currentNode.nextSibling;
					this.redesignV2DividerNodes.push(currentNode);
					currentNode = nextNode;
				}
			}

			const relocationEnabled = this.dataset.jsRelocateContent !== 'false';
			const shouldRelocateDividerContent = relocationEnabled && window.matchMedia('(min-width: 1024px)').matches;

			if ( shouldRelocateDividerContent && !this.redesignV2DividerContentRelocated ) {
				if ( !this.redesignV2DividerDestination ) {
					this.redesignV2DividerDestination = document.createElement('div');
					this.redesignV2DividerDestination.className = 'product-gallery__relocated-info';
				}

				if ( !this.redesignV2DividerDestination.parentNode ) {
					this.productGallery.appendChild(this.redesignV2DividerDestination);
				}

				this.redesignV2DividerNodes.forEach((node) => {
					this.redesignV2DividerDestination.appendChild(node);
				});

				this.redesignV2DividerStart.classList.add('divider--relocated-source');
				this.redesignV2DividerEnd.classList.add('divider--relocated-source');
				this.redesignV2DividerContentRelocated = true;
			} else if ( !shouldRelocateDividerContent && this.redesignV2DividerContentRelocated ) {
				this.restoreRedesignV2DividerContent();
			}
		}

		restoreRedesignV2DividerContent() {
			if ( this.redesignV2DividerNodes && this.redesignV2DividerPlaceholder ) {
				this.redesignV2DividerNodes.forEach((node) => {
					this.redesignV2DividerPlaceholder.parentNode.insertBefore(node, this.redesignV2DividerPlaceholder);
				});
			}

			if ( this.redesignV2DividerDestination ) {
				this.redesignV2DividerDestination.remove();
			}

			if ( this.redesignV2DividerStart ) {
				this.redesignV2DividerStart.classList.remove('divider--relocated-source');
			}

			if ( this.redesignV2DividerEnd ) {
				this.redesignV2DividerEnd.classList.remove('divider--relocated-source');
			}

			this.redesignV2DividerContentRelocated = false;
		}

		// On mobile, move the caption/title/subtitle/rating blocks (marked with
		// data-js-product-mobile-intro) to before the gallery instead of after it.
		handleMobileIntroReorder() {

			if ( !document.body.classList.contains('pdp-redesign') ) {
				return;
			}

			if ( !this.productGallery ) {
				return;
			}

			const productText = this.querySelector('.product-text');
			if ( !productText ) {
				return;
			}

			if ( !this.mobileIntroNodes ) {
				this.mobileIntroNodes = Array.from(productText.querySelectorAll(':scope > [data-js-product-mobile-intro]'));

				if ( !this.mobileIntroNodes.length ) {
					return;
				}

				this.mobileIntroPlaceholder = document.createElement('span');
				this.mobileIntroPlaceholder.hidden = true;
				this.mobileIntroPlaceholder.className = 'product-gallery__mobile-intro-placeholder';
				productText.insertBefore(this.mobileIntroPlaceholder, this.mobileIntroNodes[0]);
			}

			if ( !this.mobileIntroNodes.length ) {
				return;
			}

			const shouldRelocateIntro = window.matchMedia('(max-width: 767px)').matches;

			if ( shouldRelocateIntro && !this.mobileIntroRelocated ) {
				if ( !this.mobileIntroDestination ) {
					this.mobileIntroDestination = document.createElement('div');
					this.mobileIntroDestination.className = 'product-gallery__mobile-intro';
				}

				if ( !this.mobileIntroDestination.parentNode ) {
					this.productGallery.parentNode.insertBefore(this.mobileIntroDestination, this.productGallery);
				}

				this.mobileIntroNodes.forEach((node) => {
					this.mobileIntroDestination.appendChild(node);
				});

				this.mobileIntroRelocated = true;
			} else if ( !shouldRelocateIntro && this.mobileIntroRelocated ) {
				this.restoreMobileIntroContent();
			}
		}

		restoreMobileIntroContent() {
			if ( this.mobileIntroNodes && this.mobileIntroPlaceholder ) {
				this.mobileIntroNodes.forEach((node) => {
					this.mobileIntroPlaceholder.parentNode.insertBefore(node, this.mobileIntroPlaceholder);
				});
			}

			if ( this.mobileIntroDestination ) {
				this.mobileIntroDestination.remove();
			}

			this.mobileIntroRelocated = false;
		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

			}
		}
	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}
